export default __webpack_public_path__ + "f6b003fe8c4eac3ea7147759e8234c80.jpg";